
<div>
    <app-bar :title="t('club_athletes_title')">
        <template #actions>
            <div class="px-10">
                <v-btn
                    v-if="permitted('admin_club_management')"
                    :to="{ name: 'club-athletes.create' }"
                    class="sm sm-h"
                    color="orange"
                >{{ t('club_athlete_title_add') }}</v-btn>
            </div>
        </template>
    </app-bar>

    <v-layout>
        <v-progress-linear
            v-if="overlay"
            absolute
            indeterminate
        ></v-progress-linear>

        <card-collection
            :meta="meta"
            :busy="overlay"
            @updated="updated"
        >
            <template #filters>
                <v-toolbar
                    elevation="0"
                    color="transparent"
                    class="mt-7"
                    height="56"
                >
                    <v-text-field
                        v-model="queries.search"
                        @click:clear="clear"
                        class="input-search md mr-2"
                        clearable
                        outlined
                        dense
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        :label="t('general_label_search')"
                    ></v-text-field>

                    <v-select
                        v-model="queries.status"
                        :items="[ { text: '-', value: '' } ].concat(clubAthleteStatuses())"
                        class="md mr-2"
                        outlined
                        dense
                        append-icon="mdi-chevron-down"
                        hide-details
                        :label="t('club_athlete_label_status')"
                    ></v-select>

                    <v-btn
                        @click="search"
                        class="sm mx-5"
                        color="primary"
                    >{{ t('general_action_search') }}</v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                        v-ripple="false"
                        plain
                        color="orange darken-4"
                        @click="reset"
                    >{{ t('general_action_reset_filters') }}</v-btn>
                </v-toolbar>
            </template>

            <template #data>
                <thead>
                <tr>
                    <th class="touched">
                        <sort-field
                            v-model="queries.sort"
                            field="id"
                            @touched="onSort"
                        >{{ t('club_athlete_label_id') }}
                        </sort-field>
                    </th>
                    <th>
                        <sort-field
                            v-model="queries.sort"
                            field="name"
                            @touched="onSort"
                        >{{ t('club_athlete_label_name') }}
                        </sort-field>
                    </th>
                    <th>{{ t('club_athlete_label_medals') }}</th>
                    <th>{{ t('club_athlete_label_status') }}</th>
                    <th class="text-center">{{ t('general_label_action') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="collection.data.length === 0">
                    <td class="text-center" colspan="5">{{ t('general_text_no_data') }}</td>
                </tr>
                <template v-else v-for="item in collection.data">
                    <tr>
                        <td>
                            <a
                                :href="`/club-athletes/${item.id}/view`"
                                @click.prevent="touch(item)"
                            >{{ item.id }}</a>
                        </td>
                        <td>
                            <a
                                :href="`/club-athletes/${item.id}/view`"
                                @click.prevent="touch(item)"
                            >{{ item.name }}</a>
                        </td>
                        <td>{{ item.goldCount }} / {{ item.silverCount }} / {{ item.bronzeCount }}</td>
                        <td>{{ clubAthleteStatusTitle(item.status) }}</td>
                        <td class="text-center">
                            <v-menu
                                offset-y
                                left
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item
                                        v-if="permitted('admin_club_management')"
                                        @click.prevent="edit(item)"
                                    >
                                        <v-list-item-title
                                            class="customized-deep-primary--text"
                                        >{{ t('general_action_edit') }}
                                        </v-list-item-title>
                                    </v-list-item>
                                    <confirm-modal
                                        v-if="permitted('admin_club_management')"
                                        :title="t('general_title_confirm_action')"
                                        @agree="del(item)"
                                    >
                                        <template #default="{ on, attrs }">
                                            <v-list-item
                                                href
                                                v-on="on"
                                                v-bind="attrs"
                                            >
                                                <v-list-item-title
                                                    class="customized-deep-primary--text"
                                                >{{ t('general_action_delete') }}</v-list-item-title>
                                            </v-list-item>
                                        </template>
                                    </confirm-modal>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                </template>
                </tbody>
            </template>
        </card-collection>
    </v-layout>
</div>
